import axios from 'axios';

import { setAuthCookie } from 'services/authService';
import { OverriddenData } from 'components/EditableTable/types';

export const getUserHistoricalCompsDataOverrides = async () => {
  await setAuthCookie();

  return new Promise<OverriddenData[]>((resolve, reject) => {
    axios
      // .get('/mockData/userHistoricalCompsDataOverrides.json')
      .get('/api/getUserHistoricalCompsDataOverrides')
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
